import { Controller } from '@hotwired/stimulus'
export default class ConfirmModalController extends Controller {
  static targets = ['modal', 'confirmLink', 'content', 'title']

  initialize() {
    this.modal = new bootstrap.Modal(this.modalTarget);
  }

  openModal(event) {
    const { confirmHref, modalContent, modalTitle } = event.currentTarget.dataset;

    if (modalTitle) this.titleTarget.innerHTML = modalTitle;
    if (modalContent) this.contentTarget.innerHTML = modalContent;
    this.confirmLinkTarget.href = confirmHref;
    this.confirmLinkTarget.setAttribute('data-method', event.currentTarget.dataset.method || 'post');
    this.modal.show();
  }
}
